import React, { useState, useEffect, useRef } from 'react';
import { customersApi } from '../api/client';
import { CID } from './UI';

export default function CustomerSearch({ onSelect, placeholder, disabled }) {
  const [q, setQ]           = useState('');
  const [results, setRes]   = useState([]);
  const [open, setOpen]     = useState(false);
  const [loading, setLoad]  = useState(false);
  const timer = useRef(null);
  const wrap  = useRef(null);

  useEffect(() => {
    const close = e => { if (wrap.current && !wrap.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  useEffect(() => {
    if (q.length < 2) { setRes([]); setOpen(false); return; }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      setLoad(true);
      try {
        const { data } = await customersApi.list({ q, page_size: 8 });
        setRes(data);
        setOpen(true);
      } catch {} finally { setLoad(false); }
    }, 280);
    return () => clearTimeout(timer.current);
  }, [q]);

  const pick = c => {
    onSelect(c);
    setQ('');
    setRes([]);
    setOpen(false);
  };

  return (
    <div style={{ position: 'relative', flex: 1 }} ref={wrap}>
      <input
        value={q}
        onChange={e => setQ(e.target.value)}
        placeholder={placeholder || 'Search customer by name / ID / phone…'}
        autoComplete="off"
        disabled={disabled}
        style={{ width: '100%' }}
      />
      {open && (
        <div className="cust-dd">
          {loading && <div className="cust-dd-item cust-dd-hint">Searching…</div>}
          {!loading && results.length === 0 && (
            <div className="cust-dd-item cust-dd-hint">No customers found</div>
          )}
          {results.map(c => (
            <div key={c.id} className="cust-dd-item" onMouseDown={() => pick(c)}>
              <span style={{ fontWeight: 600 }}>{c.full_name}</span>
              <CID code={c.customer_code}/>
              {c.phone && <span className="cust-dd-meta">{c.phone}</span>}
              {c.district && <span className="cust-dd-meta">{c.district}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
